import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';

const TopLine = styled('div')({
  height: 5,
  background: 'linear-gradient(90deg, #00ab55, #d2ffe8)',
  marginBottom: 10
});

const DialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
  '& .MuiDialogTitle-root': {
    margin: 0,
    padding: theme.spacing(1)
  }
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  '& .closeButton': {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
}));

export const DialogContent = styled(MuiDialogContent)(({ theme, textAlign }) => ({
  padding: theme.spacing(1),
  textAlign: textAlign || 'left'
}));

export const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1)
}));

const CustomDialog = (props) => {
  const { children, open, onClose, title, ...rest } = props;

  return (
    <Dialog
      {...rest}
      aria-labelledby="customized-dialog-title"
      open={open === undefined ? true : open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(event, reason);
        }
      }}
    >
      <TopLine />
      <StyledDialogTitle id="customized-dialog-title">
        <Typography variant="h6" style={{ color: '#00ab55' }}>
          {title}
        </Typography>
        {onClose ? (
          <IconButton 
            aria-label="close" 
            className="closeButton" 
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'grey.500'
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        ) : null}
      </StyledDialogTitle>
      {children}
    </Dialog>
  );
};

CustomDialog.propTypes = {
  children: PropTypes.any,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string
};

export default CustomDialog;
